export const initialProductState = {
    loading: false,
    error: null,
    dataProduct: null,
};
